import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { DocumentListItem } from "../documents/documents.js";
import {
    BaseColumn, DropDownColumn,
    EditableGrid,
    field, InGridButtonClickParams, InGridToolBarButton,
    Schema
} from "../core/components/editableGrid/editableGrid.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { ToolBarInGridButtonType } from "../core/components/toolBar.js";
import { InGridButtonEnabledParams } from "../address/openingHoursInGrid.js";
import { ModalDialogProps, ModalHelper } from "../../siteManagement/showmodal.js";
import { Config } from "../core/config/config.js";
import { Dialog, DialogAction, DialogProps } from "../core/components/dialog.js";
import { DropDownList, DropDownListProps } from "../core/components/dropDownList.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { FieldInstance } from "../core/components/field.js";
import React from "react";
export default class DocumentsDetailsApp extends React.Component<DocumentsDetailsAppProps, DocumentsDetailsAppState> {
    common = new AppHelper();
    saveEnabled = true;
    documentTreeActivated: boolean = false;
    gridOptions: kendo.ui.GridOptions;
    editableGridRef: EditableGrid;
    constructor(props: DocumentsDetailsAppProps) {
        super(props);
        this.state = {
            dataLoaded: false,
            subCategories: [],
            Columns: null
        }

        const metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "documentsGridOptions");
        this.gridOptions = metaDataAdditional.length > 0 ? metaDataAdditional[0].data as any : null;

        this.common.enableHooks = true;
        this.common.init(this);
        this.documentTreeActivated = this.props.documentTreeActivated;
    }

    private refreshChoices = () => {
        const res: { Value: any, Text: any }[] = [];
        this.state.subCategories.forEach(s => {
            res.push({ Value: s.Id, Text: s.TranslatedBeschreibung });
        })
        return res;
    }

    componentDidMount() {
        this.common.setEntityDirtyState(true);
    }

    private setSubCategoriesFiltered = (kategId: number) => {
        let tmp = [];
        if (Helper.hasValue(kategId))
            tmp = this.props.dataSources.docSubCategories.filter(x => x.KategId == kategId);
        this.setState({ subCategories: tmp });
    }

    save = async () => {
        if (this.common.validate()) {
            const data = this.editableGridRef.getData();
            const result = await HTTPService.post<JsonResultClass>("Document/SaveMultipleDetails", {
                details: data,
                type: this.props.type,
                refid: this.props.refId,
                table: this.props.table,
                cancelable: true
            })
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, true);
        }
    }

    private flag = false;
    private onDataChanged = (action: "itemchange" | "add" | "remove", fieldName: string, dataItems: any[]) => {
        if (action == "itemchange" && !this.flag) {
            if (fieldName == "Kategid") {
                this.flag = true;
                this.setSubCategoriesFiltered(dataItems[0].Kategid);
                dataItems[0].set("SubKategId", null);
                this.flag = false;
            }
        }
    }

    private onEditEnd = () => {
        this.common.setEntityDirtyState(true);
    }

    private onLayout = (columns: BaseColumn[], schema: Schema) => {
        schema.Id = "IsGuid";
        schema.fields["IsGuid"] = new field("string");

        const c = columns.find(f => f.field == "SubKategId");
        (c as DropDownColumn).refreshChoices = this.refreshChoices;
    }
    private _handleButtonClick = async (params: InGridButtonClickParams) => {
        if (params.id == "categories") {
            const modal = ModalHelper.createModal<SelectCategoriesDialogProps>(SelectCategoriesDialog);
            const props: SelectCategoriesDialogProps = {
                onOk: () => { },
                onCancel: () => { },
                params: params,
                dataSourceCategory: this.props.dataSources.docCategories,
                dataSourceSubCategory: this.props.dataSources.docSubCategories,
                catValue: null,
                subCatValue: null,
                subCategoryVisible: this.props.subCategoryVisible
            }

            await modal(props);
            this.setState({});
        }

        if (params.id == "folder") {
            const modal = ModalHelper.createModal<SelectPathDialogProps>(SelectPathDialog);
            const props: SelectPathDialogProps = {
                onOk: () => { },
                onCancel: () => { },
                params: params,
                dataSource: this.props.dataSources.pathsList
            }

            await modal(props);
            this.setState({});
        }
    }

    private _handleEnabled = (params: InGridButtonEnabledParams): boolean => {
        return this.props.entity.RecordRight.CanWrite && params.selectedItems.length > 0
    }



    renderGrid = () => {

        const editable = this.props.entity.RecordRight.CanWrite;

        const buttons: Array<InGridToolBarButton> = [];
        if (this.props.dataSources.docCategories.length > 0)
            buttons.push({
                type: ToolBarInGridButtonType.CUSTOM, id: "categories",
                caption: getTitle(this.props.subCategoryVisible),
                enabled: this._handleEnabled,
                useContextMenu: true,
                iconClass: "k-i-pencil"
            });
        if (this.props.dataSources.pathsList.length > 0 && this.props.folderVisible)
            buttons.push({
                type: ToolBarInGridButtonType.CUSTOM, id: "folder",
                caption: Config.translations.editLabel + ' ' + Helper.getTranslation("WebSMS.Skills.Folder"),
                enabled: this._handleEnabled,
                iconClass: "k-i-folder"
            });

        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid
                data={this.props.entity.DocumentsDetails}
                gridOptions={this.gridOptions}
                id="documentsGridOptions"
                ref={(ref) => this.editableGridRef = ref}
                validatable={false}
                editable={editable}
                onDataChanged={this.onDataChanged}
                onLayoutReady={this.onLayout}
                onEditEnd={this.onEditEnd}
                onButtonClick={this._handleButtonClick}
                buttons={buttons}
                gridDetails={{ useFeature: true }}
                useFloatingButtons={true}
                {... this.props}
            />
        </div>
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), {});
        return <CommonApp {...props} />;
    }
}

interface SubCategoryLookUpViewModel {
    Id?: number;
    KategId?: number;
    TranslatedBeschreibung?: string;
}

export interface DocumentsDetailsAppState {
    dataLoaded: boolean,
    subCategories: SubCategoryLookUpViewModel[],
    Columns: BaseColumn[];
}
export interface DocumentsDetailsAppProps extends AppBaseProps {
    context: DocumentsDetailsContext;
    entity: DocumentsDetailsEntity;
    ids: string[];
    type: number;
    refId: string;
    table?: string;
    documentTreeActivated?: boolean;
    documents?: DocumentListItem[];
    dataSources: {
        docCategories?: any[];
        docSubCategories?: any[];
        pathsList?: any[];
        docStatus?: any[];
    },
    subCategoryVisible: boolean,
    folderVisible: boolean
}

function getTitle(subCategoryVisible: boolean) {
    const ext = subCategoryVisible ?
        Helper.getTranslation("Field.Dokument.kategid") + '/' + Helper.getTranslation("Field.Dokument.Subcategory") :
        Helper.getTranslation("Field.Dokument.kategid");
    return Config.translations.editLabel + ' ' + ext;
}

interface DocumentsDetailsContext extends Context {
}

export interface DocumentsDetails {
    DokuId: number;
    Titel: string;
    Nurintern: number;
    Bemerkung: string;
    Kategid: number;
    AnlageLogIn: string;
    Verzeichnis: string;
    Dokutyp: number;
    IsHyperlink: boolean;
    OnlyInternal: boolean;
    LocatedLocallyRessource: string;
    SubKategId: number;
    VirtualFolderOriginal?: string;
    VirtualFolderTranslated?: string;
    IsGuid: string;
}

export interface DocumentsDetailsEntity extends Entity {
    DocumentsDetails: DocumentsDetails[];
}


export interface SelectPathDialogProps extends ModalDialogProps {
    dataSource: any;
    params: InGridButtonClickParams
}

export class SelectPathDialog extends React.Component<SelectPathDialogProps, { value: string }> {
    private _factory = ComponentHelper.createFactory();
    private GetDialogActions = (): Array<DialogAction> => {
        return [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onCancel();
                },
                cancel: true
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.params.selectedItems.forEach(s => {
                        const x = this.props.params.dataSource.getByUid((s as any).uid);
                        x.set("VirtualFolder", this.state.value);
                    });
                    this.props.onOk();
                },
                primary: true
            }];
    }

    constructor(props: SelectPathDialogProps) {
        super(props)
        this.state = {
            value: ""
        }
    }

    private _createDropDownList = () => {
        let props: DropDownListProps = this._factory.getDefaultDropDownProps();
        props.value = this.state.value;
        props.dataSource = this.props.dataSource;
        props.field.dataTextField = "path";
        props.field.dataValueField = "path";
        props.field.optionLabel = "";

        props.onChange = (_field: any, value: any) => {
            this.setState({ value: value })
        }

        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.Skills.Folder")} noHover={true} labelLabelStyle={{ width: "300px" }} >
                <DropDownList {...props} />
            </FieldInstance>);
    }

    render() {
        const props: DialogProps = {
            title: Config.translations.editLabel + ' ' + Helper.getTranslation("WebSMS.Skills.Folder"),
            actions: this.GetDialogActions(),
            modalCancelTimeout: 5 * 60,
            afterClose: () => {
            },
            open: true,
            isFlex: true,
            width: 300
        }

        const dropDown = this._createDropDownList();

        return <Dialog {...props} >
            {dropDown}
        </Dialog>
    }
}

export interface SelectCategoriesDialogProps extends ModalDialogProps {
    dataSourceCategory: any;
    dataSourceSubCategory: any;
    params: InGridButtonClickParams;
    catValue: any;
    subCatValue: any;
    subCategoryVisible: boolean;
}


export interface SeslectCategoriesDialogState {
    catValue: any;
    subCatValue: any;
    subCategories: SubCategoryLookUpViewModel[];
}
export class SelectCategoriesDialog extends React.Component<SelectCategoriesDialogProps, SeslectCategoriesDialogState> {
    private _factory = ComponentHelper.createFactory();
    private _ref: DropDownList;
    private GetDialogActions = (): Array<DialogAction> => {
        return [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onCancel();
                },
                cancel: true
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.params.selectedItems.forEach(s => {
                        const x = this.props.params.dataSource.getByUid((s as any).uid);
                        x.set("Kategid", this.state.catValue);
                        x.set("SubKategId", this.state.subCatValue);
                    });
                    this.props.onOk();
                },
                primary: true
            }];
    }

    constructor(props: SelectCategoriesDialogProps) {
        super(props)
        this.state = {
            catValue: null,
            subCatValue: null,
            subCategories: null
        }
    }

    private setSubCategoriesFiltered = (kategId: number) => {
        let tmp = [];
        if (Helper.hasValue(kategId))
            tmp = this.props.dataSourceSubCategory.filter((x: { KategId: number; }) => x.KategId == kategId);
        if (this._ref)
            $.extend(this._ref.props.dataSource, tmp);
        this.setState({ subCategories: tmp, catValue: kategId, subCatValue: null });
    }

    private _createCategoryDropDownList = () => {
        let props: DropDownListProps = this._factory.getDefaultDropDownProps();
        props.value = this.state.catValue;
        props.dataSource = this.props.dataSourceCategory;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.optionLabel = "";

        props.onChange = (_field: any, value: any) => {
            this.setSubCategoriesFiltered(value);
        }

        return (
            <FieldInstance label={Helper.getTranslation("Field.Dokument.kategid")} noHover={true} labelLabelStyle={{ width: "300px" }} >
                <DropDownList {...props} />
            </FieldInstance>);
    }

    private _createSubCategoryDropDownList = () => {
        let props: DropDownListProps = this._factory.getDefaultDropDownProps();
        props.value = this.state.subCatValue;
        props.dataSource = this.state.subCategories;
        props.field.dataTextField = "TranslatedBeschreibung";
        props.field.dataValueField = "Id";
        props.field.optionLabel = "";
        props.field.refreshDSOnRefChange = true;

        props.onChange = (_field: any, value: any) => {
            this.setState({ subCatValue: value })
        }

        return (
            <FieldInstance label={Helper.getTranslation("Field.Dokument.Subcategory")} noHover={true} labelLabelStyle={{ width: "300px" }} >
                <DropDownList {...props} ref={(r) => this._ref = r} />
            </FieldInstance>);
    }

    render() {
        const props: DialogProps = {
            title: getTitle(this.props.subCategoryVisible),
            actions: this.GetDialogActions(),
            modalCancelTimeout: 5 * 60,
            afterClose: () => {
            },
            open: true,
            isFlex: true,
            width: 300
        }

        const catDD = this._createCategoryDropDownList();
        const catSubDD = this.props.subCategoryVisible ? this._createSubCategoryDropDownList() : null;

        return <Dialog {...props} >
            <div style={{ display: "flex", flexDirection: "column" }}>
                {catDD}
                {catSubDD}
            </div>
        </Dialog>
    }
}
